import { InjectionToken } from '@angular/core';

export const G_MAPS_API_KEY_TOKEN = new InjectionToken<string>('Google maps api key token');
